module.exports = __webpack_public_path__ + "img/syukyaku-syukyaku-pa002.4fbdfe06.png";